export default "__VITE_PUBLIC_ASSET__45570ade__"